// @flow
import i18n from "i18next";
import k from "src/i18n/keys";

import React from "react";
import { useSelector } from "react-redux";

import { getSelectedAction } from "src/reducers";

import ChatTimestamp from "src/components/messages/Chat/ChatTimestamp";
import NameOrEmail from "src/containers/user/NameOrEmail";
import User from "src/components/user/Photo";
import SelectIndicator from "src/components/messages/Chat/SelectIndicator";

import type { Message } from "src/types";

import {
  UserInfo,
  MessageHeader,
  MessageCard,
  ChatCard,
  GenericNotification as StyledGenericNotification,
  NotificationNameOrEmail,
} from "../styles";

type Props = {
  message: Message,
  isCurrentUser: boolean,
  first?: boolean,
  timestamp?: string,
  hideTimestamp?: boolean,
  children?: React$Node,
};

const GenericNotification = ({
  message,
  isCurrentUser,
  first,
  timestamp,
  hideTimestamp = false,
  children,
}: Props) => {
  const showSelect = useSelector(({ app }) => getSelectedAction(app));

  return (
    <StyledGenericNotification first={first} showSelect={showSelect}>
      <SelectIndicator
        id={message.id}
        timestamp={timestamp}
        isOwner={isCurrentUser}
        disabled={true} // FIXME: Remove this once we have a way to select all notifications
      />
      <ChatCard first={first} showSelect={showSelect}>
        {first && (
          <UserInfo>
            <User uid={message.author} size="sm" />
          </UserInfo>
        )}
        <MessageCard first={first}>
          <MessageHeader>
            <div>
              {isCurrentUser ? (
                <NotificationNameOrEmail>
                  {i18n.t(k.YOU)}
                </NotificationNameOrEmail>
              ) : (
                <NameOrEmail uid={message.author} notificationVariant="key" />
              )}{" "}
              {children}
            </div>
            {!hideTimestamp && (timestamp || message.timestamp) ? (
              <ChatTimestamp
                read={message.read}
                delivered={message.delivered}
                timestamp={timestamp ?? message.timestamp}
              />
            ) : null}
          </MessageHeader>
        </MessageCard>
      </ChatCard>
    </StyledGenericNotification>
  );
};

export default GenericNotification;
